import { Injectable } from '@angular/core';

import { RenditionService } from '@alfresco/adf-content-services';

@Injectable({
  providedIn: 'root',
})
export class WkViewUtilService {
  constructor(private readonly renditionService: RenditionService) {}

  printFileGeneric(objectId: string, mimeType: string): void {
    return this.renditionService.printFileGeneric(objectId, mimeType);
  }
}
